<partial-loading-indicator class="dex-lp-w_loading-indicator">

    <div class="dex-lp-w_plates">
        <dex-lp-part-plate
            [isCollapsed]="true">
            <dex-lp-details-part
                [lp]="widgetImpl.$lp()"
                [tranches]="widgetImpl.$traches()"
                [isCollapsed]="true"
                [isSymbolClickable]="true">
            </dex-lp-details-part>
        </dex-lp-part-plate>

        @for (tranche of widgetImpl.$traches(); track tranche.raw.poolTrancheId) {
            <dex-lp-part-plate [isCollapsed]="true">
                <dex-tranche-details-part
                    [tranche]="tranche"
                    [isCollapsed]="true"
                    [isExpandCollapseEnabled]="false"
                    [isSymbolClickable]="true"
                    (symbolClick)="handleSymbolClick($event)"
                    (tradeClick)="handleTradeClick(tranche.unitDeliverable.symbol, $event)">
                </dex-tranche-details-part>
            </dex-lp-part-plate>
        }
    </div>

</partial-loading-indicator>
